import React from 'react';

import ActionButton from './ActionButton';

const SessionEndedButton = () => (
  <ActionButton disabled>
    Session Ended
  </ActionButton>
);

export default SessionEndedButton;
